import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';

@Component({
  selector: 'md-three-dots-menu',
  templateUrl: './three-dots-menu.component.html',
  styleUrls: ['./three-dots-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeDotsMenuComponent implements AfterViewInit {
  @ViewChild('menuList', { static: false }) menuList!: ElementRef<HTMLUListElement>;
  hasContent = false;

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.hasContent = this.menuList.nativeElement.children.length > 1;
    this.cdr.detectChanges();
  }
}
